export default __webpack_public_path__ + "static/media/MotherDay_12.bae7a4b9.png";